export default {
	styleOverrides: {
		primary: ({ theme }) => ({
			fontSize: theme.typography.body2.fontSize,
			fontWeight: 500,
			lineHeight: theme.typography.body2.lineHeight,
		}),
		secondary: ({ theme }) => ({
			fontSize: theme.typography.caption.fontSize,
			lineHeight: theme.typography.caption.lineHeight,
		}),
	},
}
